import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { sendPaymentUpfrontLink } from '../../../actions/Booking';

class SendPaymentUpfrontLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customerLink: '',
    };
  }

  upfrontPaymentLink = () => {
    const request = {
      locator: this.props.booking.locator,
      email: this.props.booking.cli_email,
      session: this.props.sessionId,
    };

    this.props.dispatch(sendPaymentUpfrontLink(request)).then((paymentUrl) => {
      this.setState({ customerLink: paymentUrl });
    });
  };

  renderPaymentLink() {
    if (!this.state.customerLink) {
      return null;
    }
    return (
      <div>
        {this.context.t('Customer link')}:
        <div className="link-content">{this.state.customerLink}</div>
      </div>
    );
  }

  render() {
    if (this.props.booking.status !== 'CONF') {
      return null;
    }
    return (
      <div className="SendPaymentUpfront">
        <button className="btn btn-large btn-primary mt-2 py-2" onClick={this.upfrontPaymentLink}>
          {this.context.t('Send a link for an upfront payment for this booking')}
        </button>
        {this.renderPaymentLink()}
      </div>
    );
  }
}

SendPaymentUpfrontLink.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  sessionId: state.bookingFormState.sessionId,
}))(SendPaymentUpfrontLink);
